/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {schema} from '../../schema';

export {schema, marks, nodes} from '../../schema';
export default schema;
